import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order container" }
const _hoisted_2 = {
  key: 0,
  class: "order__list"
}
const _hoisted_3 = ["index"]
const _hoisted_4 = { class: "slide__body" }
const _hoisted_5 = { class: "slide__content" }
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "slide__desc" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "slide__body" }
const _hoisted_10 = { class: "slide__content" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "slide__desc" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "order__chat chat" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "chat__content" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "chat__title" }, " Мы предлагаем вам простой инструмент, чтобы автоматизировать информирование о поступающих оплатах. "),
  /*#__PURE__*/_createElementVNode("p", { class: "chat__desc" }, " Бухгалтер на карантине, а директор недоступен? Ответственный сотрудник моментально узнает о поступлении денег на счет компании. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmallForm = _resolveComponent("SmallForm")!
  const _component_slide = _resolveComponent("slide")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.store.isDesktop)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData, (slide, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              index: index,
              class: "order__item slide"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h2", {
                    id: `title-${slide.id}`,
                    class: "slide__title title"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(slide.desc), 1),
                  _createVNode(_component_SmallForm, { class: "slide__form" })
                ]),
                _createElementVNode("img", {
                  class: "slide__image",
                  src: _ctx.IMAGE_BASE_URL + slide.imgUrl,
                  alt: "Иллюстрация услуги"
                }, null, 8, _hoisted_8)
              ])
            ], 8, _hoisted_3))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_carousel, {
          key: 1,
          "items-to-show": 1,
          autoplay: 0,
          transition: 600
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData, (slide, index) => {
              return (_openBlock(), _createBlock(_component_slide, {
                key: index,
                index: index,
                class: _normalizeClass(["order__item slide", `slide-${index + 1}`])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h2", {
                        id: `title-${slide.id}`,
                        class: "slide__title title"
                      }, null, 8, _hoisted_11),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(slide.desc), 1),
                      _createVNode(_component_SmallForm, { class: "slide__form" })
                    ]),
                    _createElementVNode("img", {
                      class: "slide__image",
                      src: _ctx.IMAGE_BASE_URL + slide.imgUrl,
                      alt: "Иллюстрация услуги"
                    }, null, 8, _hoisted_13)
                  ])
                ]),
                _: 2
              }, 1032, ["index", "class"]))
            }), 128))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("img", {
        src: _ctx.IMAGE_BASE_URL + 'sign.png',
        alt: "",
        class: "chat__lines"
      }, null, 8, _hoisted_15),
      _createElementVNode("img", {
        src: _ctx.IMAGE_BASE_URL + 'chat.png',
        alt: "Иллюстрация"
      }, null, 8, _hoisted_16),
      _hoisted_17
    ])
  ]))
}